import React, { useContext, useState } from "react";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";

import AuthContex from "../../context/AuthContext";

import Page from "../templates/page";
import FormInput from "../components/forminput";
import useTituloPagina from "../../utils/useTituloPagina";

const Login = (props) => {
  const { guardarLoggedIn } = useContext(AuthContex);
  useTituloPagina("Ingreso a la consola");

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const [error, guardarError] = useState();

  const onSubmit = async (data) => {
    try {
      await axios.post("/api/usuarios/login", data);
      guardarLoggedIn(true);
      props.history.push(`/consola`);
    } catch (err) {
      guardarError("Usuario o password inválido.");
    }
  };

  return (
    <Page>
      <form className="login-formulario" onSubmit={handleSubmit(onSubmit)}>
        <h1 className="centrado">LOGIN</h1>
        <FormInput
          register={register}
          error={errors.usuario}
          label={"Usuario:"}
          id={"usuario"}
          isRequired={true}
          placeholder="Ingresar usuario."
        />

        <FormInput
          register={register}
          error={errors.password}
          label={"Contraseña:"}
          id={"password"}
          isRequired={true}
          placeholder="Ingresar contraseña."
          type="password"
        />

        <small className="text-danger form-text" role="alert">
          {error}
        </small>

        <div className="text-center">
          <button
            type="submit"
            className="btn ppr-btn-verde font-weight-bold m-2"
          >
            Ingresar
          </button>

          <Link to={"/"} className="btn ppr-btn-verde font-weight-bold m-2">
            Volver
          </Link>
        </div>
      </form>
    </Page>
  );
};

export default withRouter(Login);
